import Vue from "vue";
import VueRouter from "vue-router";
import qs from "qs";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: to => {
      return { path: "/clipper/channels", query: to.query };
    },
    name: "Mango Studio Video Editor",
    // component: () => import("../components/Editor.vue"),
    meta: {
      title: "MangoClipper"
    }
  },

  {
    path: "/admin.html",
    alias: "/admin",
    name: "Mangomolo Admin",
    component: () => import("../components/admin/AdminPage.vue"),
    meta: {
      title: "Mangomolo Admin"
    }
  },
  {
    path: "/admin/servers/:serverId",
    name: "Mangomolo Admin",
    component: () => import("../components/admin/AdminPage.vue"),
    meta: {
      title: "Mangomolo Admin"
    },
    props: true
  },
  {
    path: "/twitter_auth",
    component: () =>
      import("../components/socials/share/TwitterCallbackPage.vue"),
    props: route => ({
      token: route.query.oauth_token,
      verifier: route.query.oauth_verifier
    })
  },

  {
    path: "/channels/:channelId",
    name: "Mango Studio Video Editor",
    component: () => import("../components/Editor.vue"),
    meta: {
      title: "MangoClipper"
    },
    props: true
  },
  {
    path: "/clipper",
    name: "Mango Studio Video Editor",
    children: [
      {
        path: "mediamanager",
        name: "Media Manager",
        component: () => import("../components/MediaManager.vue"),
        meta: {
          title: "Mango Media Manager"
        },
        props: true
      },
      {
        path: "channels/:channelId",
        name: "Mango Studio Video Editor",
        component: () => import("../components/Editor.vue"),
        meta: {
          title: "MangoClipper"
        },
        props: true
      },
      {
        path: "/",
        redirect: to => {
          return { path: "/clipper/channels", query: to.query };
        },
        name: "Mango Studio Video Editor",
        // component: () => import("../components/Editor.vue"),
        meta: {
          title: "MangoClipper"
        }
      },
      {
        path: "studio",
        // path: "studio",
        name: "Mangomolo studio",
        component: () =>
          import("../components/media/editing/EditVideoForm.vue"),
        meta: { title: "Mangomolo studio" },
        props: route => ({
          token: route.query.oauth_token,
          // verifier: route.query.oauth_verifier,
          // duration: route.query.duration,mm_video_id
          // videoInfo: route.query.videoInfo,mm_video_id
          videoInfoID: route.query.videoInfoID,
          // thumbnail: route.query.thumbnail,
          app: route.query.app,
          // videoSrc: route.query.videoSrc,
          stream: route.query.stream,
          // isUpdatingThumbnail: route.query.isUpdatingThumbnail,
          thumbs: route.query.thumbs,
          mmVideoId: route.query.mm_video_id,
          mmAudioId: route.query.mm_audio_id,
          streamId: route.query.streamId,
          currentChannel: route.query.currentChannel
          // vod: route.query.vod,
          // host: route.query.host
        })
      },
      {
        path: "channels",
        name: "Mango Studio Video Editor",
        component: () => import("../components/Editor.vue"),
        meta: {
          title: "MangoClipper"
        },
        props: true
      },
    ],
    component: () => import("../components/ClipperEditorBase.vue")
  },
  {
    path: "/*",
    name: "404",
    component: () => import("../components/errors/ErrorNotFound.vue"),
    meta: {
      title: "404"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  parseQuery(query) {
    function parse(obj) {
      // Create a new object to avoid mutating the original
      const result = Array.isArray(obj) ? [] : {};
      
      for (const key in obj) {
        const value = obj[key];
        
        // Handle arrays first to preserve array structure
        if (Array.isArray(value)) {
          result[key] = value.map(item => {
            if (typeof item === "string") {
              // Check if string is a number
              if (/^(\d+|\d*\.\d+)$/.test(item)) {
                return parseFloat(item);
              }
              // Check if string is a keyword
              const keywords = {
                true: true,
                false: false,
                null: null,
                undefined: undefined
              };
              if (item in keywords) {
                return keywords[item];
              }
            }
            // Recursively parse nested objects
            if (typeof item === "object" && item !== null) {
              return parse(item);
            }
            return item;
          });
          continue;
        }
        
        // Handle primitive values
        if (typeof value === "string") {
          // Check if string is a number
          if (/^(\d+|\d*\.\d+)$/.test(value)) {
            result[key] = parseFloat(value);
            continue;
          }
          // Check if string is a keyword
          const keywords = {
            true: true,
            false: false,
            null: null,
            undefined: undefined
          };
          if (value in keywords) {
            result[key] = keywords[value];
            continue;
          }
          result[key] = value;
          continue;
        }
        
        // Handle objects
        if (typeof value === "object" && value !== null) {
          result[key] = parse(value);
          continue;
        }
        
        result[key] = value;
      }
      
      return result;
    }
    const q = qs.parse(query);
    return parse(q);
  },
  stringifyQuery(query) {
    // Ensure arrays are properly stringified
    const result = qs.stringify(query, {
      arrayFormat: 'repeat', // Use ?key=value&key=value format for arrays
      encode: true
    });

    return result ? "?" + result : "";
  }
});

router.afterEach(to => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || "Mangomolo";
  });
});
// function hasQueryParams(route) {
//   return !!Object.keys(route.query).length
// }

// router.beforeEach((to, from, next) => {
//    if(!hasQueryParams(to) && hasQueryParams(from)){
//     next({name: to.name, query: from.query});
//   } else {
//     next()
//   }
// })

export default router;
